import busersTypes from '../../constants/busersTypes'
export * from './create'
export * from './get'
export * from './getindex'
// export * from './activate'
export * from './update'

const set_buser_errors = (messages) => {
  return {
    type: busersTypes.set_errors,
    payload: messages
  }
}

const reset_buser = () => {
  return {
    type: busersTypes.reset_buser
  }
}

const clear_buser = () => {
  return {
    type: busersTypes.clear_buser
  }
}

export {
  set_buser_errors,
  reset_buser,
  clear_buser,
}



// WEBPACK FOOTER //
// ./src/js/actions/busers/index.js